__turbopack_context__.v({
  "highlight": "HighlightedText-module__tXKNXa__highlight",
});
